// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'
import { TrackingProvider } from '@indeed/flex-tracking-context'

import EmployerNetworkList from 'syft-acp-core/entities/EmployerDetail/EmployerNetworkList'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

/**
 * Lists all venues for an employer.
 *
 * @param {Object} props Properties
 * @returns {XML} ListEntities component
 */
const EmployerNetworkListView = ({ match: { params } }) => {
  const employerName = useEmployerName(Number(params.id))

  return (
    <TrackingProvider
      value={{
        context: {
          employer_id: Number(params.id),
        },
      }}
    >
      <PageTitle title={['Networks', recordLabel('Employer', params.id, employerName)]}>
        <div className="page entity-list">
          <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
          <EmployerNetworkList
            employerID={Number(params.id)}
            urlBase={`/entity/employers/view/${params.id}/networks/view/`}
          />
        </div>
      </PageTitle>
    </TrackingProvider>
  )
}

EmployerNetworkListView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      // Note: ID gets passed as a string directly from the URL.
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerNetworkListView
